import { useParams } from 'react-router-dom';
import SemanticPageDocument from '@/components/semantic/SemanticPageDocument';
import { getDocsUseCasePage } from '@/lib/semantic-content/pages';
import NotFound from '@/pages/NotFound';

export default function DocsUseCasePage() {
  const { useCaseSlug = '' } = useParams();
  const page = getDocsUseCasePage(useCaseSlug);

  return page ? <SemanticPageDocument page={page} /> : <NotFound />;
}
